import {api} from './api.js';
import {replaceUmlaute} from './umlaut';

const brMappings = key => {
  if (key.includes('aussichten')) {
    return [
      /**
       * regex usage: /^TX_( group1 )="( group2 )"/gi
       *
       * placeholders for regex group1 in jsontree:
       * - use @ as string placeholder
       * - use $ as int placeholder
       * - use [field=$] for array elements with specific field
       *
       * group2 will be applied as parameter with jsonkey
       * */

      // nacht-franken temperatures
      {
        prefix: 'T_min_',
        jsontree: 'maps.' + key + '.items.t_min_@.data.temperature.value'
      },
      {
        prefix: 'T_max_',
        jsontree: 'maps.' + key + '.items.t_max_@.data.temperature.value'
      },
      {
        prefix: 'P_',
        jsontree: 'maps.' + key + '.items.p_@.data.iconIndex.value'
      }
    ];
  } else {
    return [
      /**
       * regex usage: /^TX_( group1 )="( group2 )"/gi
       *
       * placeholders for regex group1 in jsontree:
       * - use @ as string placeholder
       * - use $ as int placeholder
       * - use [field=$] for array elements with specific field
       *
       * group2 will be applied as parameter with jsonkey
       * */

      // nacht-franken temperatures
      {
        prefix: 'T_min_',
        jsontree: 'maps.' + key + '.items.t_min_@.data.temperature.value'
      },
      {
        prefix: 'T_max_',
        jsontree: 'maps.' + key + '.items.t_max_@.data.temperature.value'
      },
      {
        prefix: 'P_n_',
        jsontree: 'maps.' + key + '.items.p_n_@.data.iconIndex.value'
      },
      {
        prefix: 'P_t_',
        jsontree: 'maps.' + key + '.items.p_t_@.data.iconIndex.value'
      }
    ];
  }
};

let loaded = {};

const addNewBranch = (data, txtkey, txtval, mapping) => {
  const tree = mapping.jsontree;
  // console.log( txtkey + " " + txtval);
  let pos = data;
  try {
    tree.split('.').forEach((key, i, a) => {
      key = key.replace('@', txtkey);

      if (txtkey.includes('amberg')) {
        // console.log(map + "\t" + key +"\t" + txtkey + "\t" + i + "\t" + a);
        // console.log(pos[key])
      }

      // console.log(key + " " + i + " " + a);
      /**
       ** HERE THE VALUE GETS WRITTEN **
       * last key? write value and break loop
       */
      // #TODO: check for different types in txt file .. always float/numeric?
      if (i === a.length - 1) {
        // console.log(pos[key])
        if (typeof pos[key] === 'undefined') {
          // console.log(Object.keys(data.maps).length);
          // return data;
        } else {
          // console.log(pos)
        }
        pos[key] = parseFloat(txtval);
        throw new Error();
      }

      if (typeof pos[key] === 'undefined') {
      }

      pos = pos[key];
    });
  } catch {}
  return data;
};

const processLine = (data, line, key) => {
  const br = brMappings(key);
  br.some(function (mapping) {
    const regex = new RegExp('^' + mapping.prefix + '(.+)="(.+)"', 'gi');
    const match = regex.exec(line);
    if (!match || match.length < 3) return false;

    const txtkey = replaceUmlaute(match[1].toLowerCase());
    const txtval = match[2].toLowerCase();

    data = addNewBranch(data, txtkey, txtval, mapping, key);

    return true;
  });
  return data;
};

const filterLine = line => {
  if (line.length === 0) return false;
  if (line.substring(0, 2) === '/*') return false;

  return true;
};

const writeStringDataToObject = (data, str) => {
  Object.keys(data.maps).forEach(key => {
    let lines = str.split('\n');
    lines = lines.filter(filterLine);
    lines.forEach(line => {
      data = processLine(data, line, key);
    });
  });

  return data;
};

/**
 * loads text from current host
 *
 * @param {string} path - url path (added to current host)
 *
 * @return {string} file content as string
 * */
const loadTxtToString = async path => {
  try {
    const response = await fetch(api.files.readTxt(path));
    return response.text();
  } catch (error) {
    console.error(error);
    return '';
  }
};

/**
 * generates object from text file once,
 * data is saved and reused from "loaded"
 * in case textfiles in filesystem change, "reset" has to be called
 *
 * @param data
 * @param {string} path - url path (added to current host)
 *
 * @return {object} object containing member tree specified in "mapping"
 * */
const parseMOSData = async (data, path) => {
  if (loaded[path]) return loaded[path];

  const str = await loadTxtToString(path);
  data = writeStringDataToObject(data, str, path);
  loaded[path] = data;

  return data;
};

export {parseMOSData};
